<section id="registration-main">
  <h1 class="registratioin-page-title">Register with Medshorts</h1>
  <section id="registration-card-section">
    <div class="registration-card">
      <h2 class="card-title">Pharmacies</h2>
      <img
        class="card-img"
        src="/assets/img/static-pages/medshorts/MS_Isometric Illustrations_2-01.png"
        alt="Pharmacy Building"
      />
      <p class="card-copy">
        Purchase directly from a<br />
        community of pharmaceutical<br />
        manufacturers
      </p>
      <button class="card-cta" routerLink="/registration/buyer">
        Register Here
      </button>
    </div>
    <div class="registration-card">
      <h2 class="card-title">Manufacturers</h2>
      <img
        class="card-img"
        src="assets/img/static-pages/medshorts/MS_Isometric Illustrations_1-01.png"
        alt="Manufacturer Building"
      />
      <p class="card-copy">
        Easily sell surplus<br />
        inventory to pharmacies
      </p>
      <button class="card-cta" routerLink="/registration/seller">
        Register Here
      </button>
    </div>
  </section>
</section>
